module.exports = __webpack_public_path__ + "assets/702921a2d945a8a7cb88400bc48d874c.png";